import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const VehActiveTravelXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},};

    const counts = props.vehCounts
    const asset = props.asset && props.asset.replace('&','and')


    const dataVehCount = [];
    const dataModalDist = [];
    let total_active = 0
    let total_vehicles = 0
    let total_trips = 0
    // let modal_active = 0
    let modal_vehicles = 0
    // let busy_active = 0
    let busy_peds = 0
    let busy_bikes = 0
    let busy_vehicles = 0
    // let modal_dist_active = 0
    let modal_dist_peds = 0
    let modal_dist_bikes = 0
    let modal_dist_vehicles = 0

    let total_peds = 0
    let total_bikes = 0
    let total_moto = 0
    let total_car = 0
    let total_van = 0
    let total_short_truck = 0
    let total_med_truck = 0
    let total_long_truck = 0
    let total_bus = 0
    let total_undefined = 0

    let modal_peds = 0
    let modal_bikes = 0
    let modal_moto = 0
    let modal_car = 0
    let modal_van = 0
    let modal_short_truck = 0
    let modal_med_truck = 0
    let modal_long_truck = 0
    let modal_bus = 0
    let modal_undefined = 0

    const headVehCount = [
        [
            {value: "Date", style: headerStyle},
            {value: "Pedestrians", style: headerStyle},
            {value: "Bikes", style: headerStyle},
            {value: "Vehicles", style: headerStyle},
        ],
    ]

    let headModalPercVeh = []
    if (total_med_truck === 0 && total_bus===0)
        headModalPercVeh = [
            [
                // {value: "Pedestrian", style: headerStyle},
                // {value: "Bikes", style: headerStyle},
                {value: "Mortorbikes", style: headerStyle},
                {value: "Car", style: headerStyle},
                {value: "Van", style: headerStyle},
                {value: "Short Truck", style: headerStyle},
                {value: "Long Truck", style: headerStyle},
                {value: "Undefined", style: headerStyle},
            ],
        ]
    else
        headModalPercVeh = [
            [
                // {value: "Pedestrian", style: headerStyle},
                // {value: "Bikes", style: headerStyle},
                {value: "Mortorbikes", style: headerStyle},
                {value: "Car", style: headerStyle},
                {value: "Van", style: headerStyle},
                {value: "Short Truck", style: headerStyle},
                {value: "Med Truck", style: headerStyle},
                {value: "Long Truck", style: headerStyle},
                {value: "Bus", style: headerStyle},
                {value: "Undefined", style: headerStyle},
            ],
        ]

    const headVehvActive = [
        [
            {value: "Pedestrians", style: headerStyle},
            {value: "Bikes", style: headerStyle},
            {value: "Vehicles", style: headerStyle},
        ]
    ]
   

    if (counts.length >0){
        for (let i = 0; i < counts[0].date_iso.length; i++) {
            dataVehCount.push([
                counts[0].date_iso[i],
                counts[0].peds[i],
                counts[0].bikes[i],
                counts[0].vehicles[i],

            ])
        }

        total_active = counts[0].active_travel.reduce((sum, item) => {return sum = sum + item }, 0)
        total_vehicles = counts[0].vehicles.reduce((sum, item) => {return sum = sum + item }, 0)
        total_trips = total_active + total_vehicles

        // modal_active = Math.round((total_active/total_trips)*100);
        modal_vehicles = ((total_vehicles/total_trips)*100).toFixed(2) || 0;

        total_peds = (counts[0].length>0 && counts[0].peds.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_bikes = (counts[0].length>0 && counts[0].bikes.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_moto = (counts[0].length>0 && counts[0].moto.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_car = (counts[0].length>0 && counts[0].car.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_van = (counts[0].length>0 && counts[0].van.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_short_truck = (counts[0].length>0 && counts[0].short_truck.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_med_truck = (counts[0].length>0 && counts[0].med_truck.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_long_truck = (counts[0].length>0 && counts[0].long_truck.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_bus = (counts[0].length>0 && counts[0].bus.reduce((sum, item) => {return sum = sum + item }, 0)) || 0
        total_undefined = (counts[0].length>0 && counts[0].undefined.reduce((sum, item) => {return sum = sum + item }, 0)) || 0

        modal_peds = ((total_peds/total_trips)*100).toFixed(2) || 0;
        modal_bikes = ((total_bikes/total_trips)*100).toFixed(2) || 0;
        modal_moto = ((total_moto/total_vehicles)*100).toFixed(2) || 0;
        modal_car = ((total_car/total_vehicles)*100).toFixed(2) || 0;
        modal_van = ((total_van/total_vehicles)*100).toFixed(2) || 0;
        modal_short_truck = ((total_short_truck/total_vehicles)*100).toFixed(2) || 0;
        modal_med_truck = ((total_med_truck/total_vehicles)*100).toFixed(2) || 0;
        modal_long_truck = ((total_long_truck/total_vehicles)*100).toFixed(2) || 0;
        modal_bus = ((total_bus/total_vehicles)*100).toFixed(2) || 0;
        modal_undefined = ((total_undefined/total_vehicles)*100).toFixed(2) || 0;

        // busy_active = counts[0].active_travel.reduce((acc, item) => acc = acc > item ? acc : item, 0);
        busy_peds = counts[0].peds.reduce((acc, item) => acc = acc > item ? acc : item, 0);
        busy_bikes = counts[0].bikes.reduce((acc, item) => acc = acc > item ? acc : item, 0);
        busy_vehicles = counts[0].vehicles.reduce((acc, item) => acc = acc > item ? acc : item, 0);

        // modal_dist_active = counts[0].active_travel.map((item,i) => (Math.round((item/(item + counts[0].vehicles[i]))*100) || 0));
        // modal_dist_vehicles = counts[0].vehicles.map((item,i) => (Math.round((item/(item + counts[0].active_travel[i]))*100) || 0));
        modal_dist_peds = counts[0].peds.map((item,i) => ((item/(counts[0].active_travel[i] + counts[0].vehicles[i]))*100).toFixed(2) || 0);
        modal_dist_bikes = counts[0].bikes.map((item,i) => ((item/(counts[0].active_travel[i] + counts[0].vehicles[i]))*100).toFixed(2) || 0);
        modal_dist_vehicles = counts[0].vehicles.map((item,i) => ((item/(item + counts[0].active_travel[i]))*100).toFixed(2) || 0);


        for (let i = 0; i < counts[0].date_iso.length; i++) {
            dataModalDist.push([
                counts[0].date_iso[i],
                modal_dist_peds[i],
                modal_dist_bikes[i],
                modal_dist_vehicles[i],

            ])
        }

    }

    const dataVehvActive = [[total_peds, total_bikes, total_vehicles]]
    const dataModalPerc = [[modal_peds, modal_bikes, modal_vehicles]]
    const dataBusiestDay = [[busy_peds, busy_bikes, busy_vehicles]]
    let dataModalPercVeh = []
   
   if (total_med_truck === 0 && total_bus===0)
        dataModalPercVeh = [[modal_moto, modal_car, modal_van, modal_short_truck, modal_long_truck, modal_undefined]]
   else
        dataModalPercVeh = [[modal_moto, modal_car, modal_van, modal_short_truck, modal_med_truck, modal_long_truck, modal_bus, modal_undefined]]
 
    
    let dateFrom = ""
    if (props.dateFrom){
        const d = new Date(props.dateFrom);
        dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
    }
    let dateTo = ""
    if (props.dateTo){
        const d = new Date(props.dateTo);
        dateTo = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
    }

    const dt = "Date From:" + dateFrom +" to: "+ dateTo

    const dataSet = [
        {   columns: [asset, dt],
            data: [ 
            [{value:"Vehicles v Active Travel", style: headerStyle2}],...headVehvActive,...dataVehvActive, "",
            [{value:"Modal Split %", style: headerStyle2}],...headVehvActive, ...dataModalPerc,"",
            [{value:"Busiest Day", style: headerStyle2}],...headVehvActive, ...dataBusiestDay,"",
            [{value: "Vehicle Count" , style: headerStyle2}],...headVehCount,...dataVehCount,"",
            [{value:"Modal Split by Class %", style: headerStyle2}],...headModalPercVeh, ...dataModalPercVeh,"",
            [{value: "Modal Distribution %" , style: headerStyle2}],...headVehCount,...dataModalDist,"",

                ],
        },
    ]

        return (
            <div>
                <ExcelFile filename={asset} element={<Button size="sm" variant="light"><FaDownload />&nbsp; Download </Button>}>
					<ExcelSheet dataSet={dataSet} name={asset} />
				</ExcelFile>
            </div>
        );
}


export default VehActiveTravelXls;


